/* eslint-disable @typescript-eslint/explicit-module-boundary-types */
import React from 'react';
import styled from 'styled-components';

import { AnimatedLoadingPlaceholder } from '../../common/animatedLoadingPlaceholder/animatedLoadingPlaceholder';

export const HourlyChartLoadingUI = () => {
    return (
        <Container>
            <SafetyTipLoadingUI>
                <AnimatedLoadingPlaceholder width={16} height='72px'/>
            </SafetyTipLoadingUI>
            <SafetyTipLoadingUI>
                <AnimatedLoadingPlaceholder width={16} height='98px'/>
            </SafetyTipLoadingUI>
            <SafetyTipLoadingUI>
                <AnimatedLoadingPlaceholder width={16} height='72px'/>
            </SafetyTipLoadingUI>
            <SafetyTipLoadingUI>
                <AnimatedLoadingPlaceholder width={16} height='72px'/>
            </SafetyTipLoadingUI>
            <SafetyTipLoadingUI>
                <AnimatedLoadingPlaceholder width={16} height='98px'/>
            </SafetyTipLoadingUI>
            <SafetyTipLoadingUI>
                <AnimatedLoadingPlaceholder width={16} height='98px'/>
            </SafetyTipLoadingUI>
            <SafetyTipLoadingUI>
                <AnimatedLoadingPlaceholder width={16} height='160px'/>
            </SafetyTipLoadingUI>
            <SafetyTipLoadingUI>
                <AnimatedLoadingPlaceholder width={16} height='160px'/>
            </SafetyTipLoadingUI>
            <SafetyTipLoadingUI>
                <AnimatedLoadingPlaceholder width={16} height='130px'/>
            </SafetyTipLoadingUI>
            <SafetyTipLoadingUI>
                <AnimatedLoadingPlaceholder width={16} height='130px'/>
            </SafetyTipLoadingUI>
            <SafetyTipLoadingUI>
                <AnimatedLoadingPlaceholder width={16} height='160px'/>
            </SafetyTipLoadingUI>
            <SafetyTipLoadingUI>
                <AnimatedLoadingPlaceholder width={16} height='98px'/>
            </SafetyTipLoadingUI>
        </Container>
    );
};

const Container = styled.div`
    display: flex;
    flex-direction: row;
    margin: auto 0 75px 0;
    padding: 0 30px;
    align-items: flex-end; 
    justify-content: space-between; 
`;

const SafetyTipLoadingUI = styled.div`
    display: flex;
    flex-direction: row;
    width: 20px;
    margin-bottom: auto 0 0 0 ;
`;
